import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Home } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const NotFoundPage = () => {
  // Запрет индексации
  useEffect(() => {
    const metaRobots = document.querySelector('meta[name="robots"]');
    if (metaRobots) {
      metaRobots.setAttribute('content', 'noindex, nofollow');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'robots';
      meta.content = 'noindex, nofollow';
      document.getElementsByTagName('head')[0].appendChild(meta);
    }
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      
      <main className="flex-1 pt-16 flex items-center justify-center px-4">
        <div className="text-center max-w-4xl mx-auto">
          <h1 className="text-[200px] md:text-[300px] lg:text-[400px] font-bold text-accent leading-none mb-8">
            404
          </h1>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6">
            Страница не найдена
          </h2>
          <p className="text-xl md:text-2xl text-muted-foreground mb-12">
            Извините, запрашиваемая страница не существует или была перемещена.
          </p>
          <Link to="/">
            <Button size="lg" className="text-lg px-8 py-6">
              <Home className="w-5 h-5 mr-2" />
              Вернуться на главную
            </Button>
          </Link>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default NotFoundPage;

